/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPDimensionMapping'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPDimensionMapping'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPDimensionMappingApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPDimensionMapping);
  }
}(this, function(ApiClient, ERPDimensionMapping) {
  'use strict';

  /**
   * ERPDimensionMapping service.
   * @module api/ERPDimensionMappingApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPDimensionMappingApi. 
   * @alias module:api/ERPDimensionMappingApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPDimensionMappingActivateDimensionGet operation.
     * @callback module:api/ERPDimensionMappingApi~eRPDimensionMappingActivateDimensionGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ERPDimensionMapping} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * activateDimension
     * @param {String} _4SAPIAppID 
     * @param {Integer} dimension 
     * @param {String} name 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.trackingLevelID 
     * @param {String} opts.trackingLevelName  (default to )
     * @param {module:api/ERPDimensionMappingApi~eRPDimensionMappingActivateDimensionGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ERPDimensionMapping}
     */
    this.eRPDimensionMappingActivateDimensionGet = function(_4SAPIAppID, dimension, name, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPDimensionMappingActivateDimensionGet";
      }

      // verify the required parameter 'dimension' is set
      if (dimension == undefined || dimension == null) {
        throw "Missing the required parameter 'dimension' when calling eRPDimensionMappingActivateDimensionGet";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling eRPDimensionMappingActivateDimensionGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'dimension': dimension,
        'name': name,
        'trackingLevelID': opts['trackingLevelID'],
        'trackingLevelName': opts['trackingLevelName']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ERPDimensionMapping;

      return this.apiClient.callApi(
        '/ERPDimensionMapping/activateDimension', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPDimensionMappingDisableDimensionGet operation.
     * @callback module:api/ERPDimensionMappingApi~eRPDimensionMappingDisableDimensionGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * disableDimension
     * @param {String} _4SAPIAppID 
     * @param {Integer} dimension 
     * @param {module:api/ERPDimensionMappingApi~eRPDimensionMappingDisableDimensionGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPDimensionMappingDisableDimensionGet = function(_4SAPIAppID, dimension, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPDimensionMappingDisableDimensionGet";
      }

      // verify the required parameter 'dimension' is set
      if (dimension == undefined || dimension == null) {
        throw "Missing the required parameter 'dimension' when calling eRPDimensionMappingDisableDimensionGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'dimension': dimension
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPDimensionMapping/disableDimension', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPDimensionMappingLoadGet operation.
     * @callback module:api/ERPDimensionMappingApi~eRPDimensionMappingLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ERPDimensionMapping} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPDimensionMappingApi~eRPDimensionMappingLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ERPDimensionMapping}
     */
    this.eRPDimensionMappingLoadGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPDimensionMappingLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ERPDimensionMapping;

      return this.apiClient.callApi(
        '/ERPDimensionMapping/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
